import { render, staticRenderFns } from "./Living.vue?vue&type=template&id=350a81ea&scoped=true&"
import script from "./Living.vue?vue&type=script&lang=ts&"
export * from "./Living.vue?vue&type=script&lang=ts&"
import style0 from "./Living.vue?vue&type=style&index=0&id=350a81ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350a81ea",
  null
  
)

export default component.exports